module.exports = __webpack_public_path__ + "fd5a608a/img/35000000-4.5086066e.png";